"use client";

import Breadcrumbs from "../../../components/molecules/Breadcrumbs/Breadcrumbs"
import PageTitleBlock from "../../../components/organisms/PageTitleBlock/PageTitleBlock"
import useGetPageTitleByPath from "../../../hooks/useGetPageTitleByPath";

const SubPageHeader = () => {
  
  const pageList = useGetPageTitleByPath()

  return (
    <>
      <PageTitleBlock
        pageTitle = {{text: pageList.title_en}}
        pageSubTitle={{text: pageList.title}}
        commonClass={pageList.title_cover_class}
      />
      <Breadcrumbs />
    </>
  )
}

export default SubPageHeader;